import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';
import { createFilterRule } from '@src/utils/filter';
import { useSelector } from 'react-redux';

// The logic of handling drilldown and globalFilter is referred from
// function dimensionDrillown to ensure the structure is consistent
export const useMultiDimensionFilters = (dimensions, rowData) => {
  const dimensionList = useSelector(allDimensionsListSelector);
  const filters: Record<string, string | null>[][] = [];

  dimensions.forEach((d) => {
    const dimensionInfo =
      (dimensionList as Record<string, string>[]).find((it) => it.groupBy === d) ?? {};

    if (!rowData[d]) {
      return;
    }
    const name = rowData[d];
    // need to transform back to 'CONVIVA_INTERNAL_UNKNOWN'
    const value = rowData[d] === 'UNKNOWN' ? 'CONVIVA_INTERNAL_UNKNOWN' : rowData[d];
    const filterByValue = createFilterRule(dimensionInfo, name, value);
    filters.push([filterByValue]);
  });

  return filters;
};
